import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'

interface MenuSlotsTrackerReturn {
  config: LinkNavTab[]
}

export const useMenuSlotsTracker = (): MenuSlotsTrackerReturn => {
  const route = useRoute()

  const config: LinkNavTab[] = [
    {
      text: 'Slots tracker',
      to: AppRoute.DemosSlotsTracker,
      selected: route.path === AppRoute.DemosSlotsTracker,
      disabled: false,
      visible: true,
    },
    {
      text: 'Tutor slot log',
      to: AppRoute.DemosTutorSlotLog,
      selected: route.path === AppRoute.DemosTutorSlotLog,
      disabled: false,
      visible: true,
    },
  ]

  return {
    config,
  }
}
